module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (121).66e8055f.jpg";